import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";

export default function MapControl(props) {
  const { bounds, center, zoom } = props;
  const map = useMap();
  const rafRef = useRef(null);

  useEffect(() => {
    if (!map) return undefined;

    const applyView = () => {
      // The map lives inside collapsible / resizable panels, so on first paint
      // (or right after the panel is shown/resized) the container can still
      // report a stale size. Re-measure before fitting, otherwise Leaflet
      // computes the zoom against the wrong size and the asset opens too far
      // out. invalidateSize() + a deferred fit gives the container its final
      // size first.
      map.invalidateSize();
      const boundsValid =
        bounds && (typeof bounds.isValid !== "function" || bounds.isValid());
      if (boundsValid) {
        map.fitBounds(bounds, { padding: [24, 24], maxZoom: 13, minZoom: 1 });
      } else if (center && zoom) {
        map.setView(center, zoom);
      }
    };

    // Defer to after two animation frames so a just-shown / just-resized
    // container has settled to its real size before we measure it.
    const raf1 = requestAnimationFrame(() => {
      rafRef.current = requestAnimationFrame(applyView);
    });

    return () => {
      cancelAnimationFrame(raf1);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [center, zoom, bounds, map]);

  // useEffect(() => {
  //     if (!map) return;

  //     if (bounds) {
  //         map.fitBounds(bounds);
  //     } else if (center && zoom) {
  //         map.setView(center, zoom);
  //     }
  // }, [bounds, center, zoom, map]);

  return null;
}
